import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavigationBlockerLayoutComponent } from './navigation-blocker-layout.component';
import { DialogModule } from '@angular/cdk/dialog';
import { NavigationBlockerDialogComponent } from './navigation-blocker-dialog/navigation-blocker-dialog.component';
import { MainNavigationModule } from 'app/components/main-navigation/main-navigation.module';

@NgModule({
    declarations: [NavigationBlockerLayoutComponent, NavigationBlockerDialogComponent],
    imports: [CommonModule, MainNavigationModule, DialogModule],
    exports: [NavigationBlockerLayoutComponent]
})
export class NavigationBlockerLayoutModule {}
